import Immutable from 'immutable';

export enum ExportSortDirection {
  ASCENDING = 'EXPORT_SORT_ASCENDING',
  DESCENDING = 'EXPORT_SORT_DESCENDING',
}

export interface RawActiveExport {
  fileid: string;
  filename: string;
  url: string;
}

export interface ActiveExportData {
  fileid: string;
  filename: string;
  url: string;
}

const defaultValues: RawActiveExport = {
  fileid: '',
  filename: '',
  url: '',
};

export const ActiveExportFactory = Immutable.Record(
  defaultValues,
  'ActiveExport'
);

export class ActiveExport extends ActiveExportFactory {
  serialize(): RawActiveExport {
    return this.toJS();
  }

  static deserialize(rawActiveExport: RawActiveExport): ActiveExport {
    return new ActiveExport({
      fileid: rawActiveExport.fileid,
      filename: rawActiveExport.filename,
      url: rawActiveExport.url,
    });
  }
}

export type ActiveExportMap = Immutable.OrderedMap<string, ActiveExport>;
